document.addEventListener('DOMContentLoaded', function () {
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.bottom >= 0;
  }

  const sliderSection = document.querySelector('.employees_review_slider');
  if (!sliderSection) return;

  const sliderContainer = sliderSection.querySelector('.employees_review_slider__block__block');
  if (!sliderContainer) return;

  const sliderItems = sliderSection.querySelectorAll('.employees_review_slider__block__item');
  if (!sliderItems.length) return;

  sliderItems.forEach((item) => {
    const clone = item.cloneNode(true);
    sliderContainer.appendChild(clone);
  });

  let position = 0;
  let animationId = null;
  let isAnimating = false;

  function animateSlider() {
    position -= 1;

    const containerWidth = sliderContainer.scrollWidth / 2;
    if (Math.abs(position) >= containerWidth) {
      position = 0;
    }

    sliderContainer.style.transform = `translateX(${position}px)`;
    animationId = requestAnimationFrame(animateSlider);
  }

  function startAnimation() {
    if (!isAnimating) {
      isAnimating = true;
      animationId = requestAnimationFrame(animateSlider);
    }
  }

  function stopAnimation() {
    if (isAnimating) {
      isAnimating = false;
      cancelAnimationFrame(animationId);
    }
  }

  function checkSliderVisibility() {
    if (isElementInViewport(sliderSection)) {
      startAnimation();
    } else {
      stopAnimation();
    }
  }

  window.addEventListener('scroll', checkSliderVisibility);

  checkSliderVisibility();
});
